import { ACCESS_LEVELS } from "../constants";
import { useTranslation } from "react-i18next";

type Props<T extends string> = {
  value: T;
  onChange: (level: T) => void;
  options?: { value: T; label: string }[];
};

const AccessLevelTabs = <T extends string>({
  value,
  onChange,
  options = ACCESS_LEVELS as { value: T; label: string }[],
}: Props<T>) => {
  const { t } = useTranslation();
  return (
    <div
      role="tablist"
      aria-label={t("mcpPage.fields.accessLevel")}
      className="inline-flex h-10 items-center gap-1 rounded-[10px] bg-secondary p-1"
    >
      {options.map(({ value: level }) => {
        const isActive = level === value;
        return (
          <button
            key={level}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(level)}
            className={`h-8 rounded-[8px] px-4 text-sm transition-colors ${
              isActive
                ? "bg-background font-semibold text-foreground"
                : "font-medium text-secondary-foreground/70 hover:text-foreground"
            }`}
          >
            {t(`mcpPage.accessLevels.${level}`)}
          </button>
        );
      })}
    </div>
  );
};

export default AccessLevelTabs;
